export default {
  common: { save: '保存', cancel: '取消', delete: '删除', edit: '编辑', view: '查看', add: '添加', search: '搜索', filter: '筛选', loading: '加载中...', error: '错误', success: '成功' },
  nav: { dashboard: '仪表板', members: '会员', membershipPlans: '会员计划', payments: '付款', attendance: '考勤', reports: '报告', gymProfile: '健身房档案', settings: '设置', logout: '登出' },
  gymProfile: { title: '健身房档案', languageSettings: '语言设置', currentLanguage: '当前语言', selectLanguage: '选择新语言', chooseLanguage: '选择语言...' },
  messages: { languageUpdated: '语言更新成功！' }
};